import type { ReactNode } from 'react';

export enum RadioBooleanOption {
	no = 'no',
	yes = 'yes',
}

export interface FormRadioProps {
	field: {
		name: string;
		isDisabled?: boolean;
		options: {
			value: string;
			label: { children: string };
			children?: ReactNode;
			isDisabled?: boolean;
		}[];
	};
	label: {
		children?: string;
	};
	messages?: { messages: { children: string } };
}
